import { createSelector } from 'reselect';

const verificationIds = state => state.deviceVerifications.ids;
const verificationModels = state => state.deviceVerifications.models;

export const selectVerificationsByDevice = deviceId => createSelector(
    [verificationIds, verificationModels],
    (ids, models) => ids
        .map(id => models[id])
        .filter(verification => verification.device_id === deviceId)
        .sort((a, b) => a.created_at - b.created_at)
);
